import { render, staticRenderFns } from "./RoundPayrate.vue?vue&type=template&id=6fb47a07&scoped=true&"
import script from "./RoundPayrate.vue?vue&type=script&lang=js&"
export * from "./RoundPayrate.vue?vue&type=script&lang=js&"
import style0 from "./RoundPayrate.vue?vue&type=style&index=0&id=6fb47a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb47a07",
  null
  
)

export default component.exports